<template>
    <section>
        <SideBar />
        <TopBar />
        <div class="content">

            <form class="mb-9" @submit.prevent="updateNews()">
                <div class="row justify-content-between align-items-end g-3 mb-5">
                    <div class="col-12 col-sm-auto col-xl-10">
                        <h2 class="mb-0" v-if="$route.params.id">Edit News</h2>
                        <h2 class="mb-0" v-else>New News</h2>
                    </div>
                    <div class="col-12 col-sm-auto col-xl-2">
                        <div class="d-flex">
                            <button type="submit" class="btn btn-primary px-5 w-100 text-nowrap">Save</button>
                        </div>
                    </div>
                </div>

                <div class="col-md-8 offset-md-2 col-12">
                    <div class="row">
                        <div class="form-group col-12">
                            <label>Titulo</label>
                            <input type="text" v-model="media.title" class="form-control form-control-sm">
                        </div>
                        <div class="form-group col-md-6 col-12">
                            <label>Type</label>
                            <input type="text" v-model="media.type" class="form-control form-control-sm" placeholder="book / newspaper / online">
                        </div>
                        <div class="form-group col-md-6 col-12">
                            <label>Slug</label>
                            <input type="text" v-model="media.slug" class="form-control form-control-sm">
                        </div>
                        <div class="form-group col-12">
                            <label>Publisher</label>
                            <input type="text" v-model="media.publisher" class="form-control form-control-sm">
                        </div>
                        <div class="form-group col-md-6 col-12">
                            <label>Author</label>
                            <input type="text" v-model="media.author" class="form-control form-control-sm">
                        </div>
                        <div class="form-group col-md-6 col-12">
                            <label>Date</label>
                            <input type="date" v-model="media.date" class="form-control form-control-sm">
                        </div>
                        <div class="form-group col-12">
                            <label>External link</label>
                            <input type="url" v-model="media.external_link" class="form-control form-control-sm">
                        </div>
                        <div class="form-group col-md-6 col-12">
                            <label>Consulted</label>
                            <input type="date" v-model="media.consulted" class="form-control form-control-sm">
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
import SideBar from '@/components/SideBarNav.vue'
import TopBar from '@/components/TopBarNav.vue'
import axios from 'axios'

export default {
    name: 'NewAdminComponent',
    components: { SideBar, TopBar },
    data() {
        return {
            media: {}
        }
    },
    created() {
        if (this.$route.params.id) {
            this.getData()
        }
    },
    methods: {
        getData() {
            axios.get(this.$url + '/mediaadmin/' + this.$route.params.id, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.$store.state.token
                }
            }).then((res) => {
                this.media = res.data
            }).catch((err) => {
                console.log(err)
            })
        },
        updateNews() {
            // Backend POST /media reads id from the body to decide create vs update.
            const payload = { ...this.media }
            if (this.$route.params.id) {
                payload.id = Number(this.$route.params.id)
            }
            axios.post(this.$url + '/media', payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.$store.state.token
                }
            }).then(() => {
                this.$router.push({ name: 'news' })
            }).catch(() => {
                this.$notify({ group: 'iasc', title: 'Error', text: 'No se pudo guardar', type: 'danger' })
            })
        }
    }
}
</script>
